import React from 'react';
import { STATIC_UPPSALA_SVG_URL } from '../../lib/constants';
import './Accordion.css';
const Accordion = (props) => {
    const [isOpen, setIsOpen] = React.useState(props.defaultOpen ?? false);
    const renderDefaultIcon = () => (React.createElement("span", { className: "flex" }, isOpen ? (React.createElement("img", { width: 20, height: 20, src: STATIC_UPPSALA_SVG_URL + 'chevron-up.svg', alt: "Open" })) : (React.createElement("img", { width: 20, height: 20, src: STATIC_UPPSALA_SVG_URL + 'chevron-down.svg', alt: "Close" }))));
    return (React.createElement("div", { className: `accordion-item ${isOpen ? 'active' : ''} ${props.disabled ? 'disabled' : ''} ${props.className ?? ''}`, style: props.style },
        React.createElement("button", { className: `accordion-header`, onClick: (e) => {
                props?.onClick?.(e);
                setIsOpen(!isOpen);
            }, title: props.title, disabled: props.disabled },
            React.createElement("span", null, props.title),
            React.createElement("div", { className: "mt-auto mb-auto" }, props.dropDownIcon ?? renderDefaultIcon())),
        isOpen && React.createElement("div", { className: "accordion-content show" }, props.content)));
};
export default Accordion;
